import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

const Settings = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const navigate = useNavigate();

  // Load the theme from localStorage on component mount
  useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      setIsDarkMode(storedTheme === "dark");
      document.documentElement.setAttribute("data-theme", storedTheme);
    } else {
      document.documentElement.setAttribute("data-theme", "light");
    }
  }, []);

  // Update the theme state and save to localStorage
  const handleDarkModeToggle = (event) => {
    const isDark = event.target.checked;
    setIsDarkMode(isDark);
    const theme = isDark ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  };

  const handleLogout = () => {
    // Clear user-related data from localStorage (authToken, token, etc.)
    localStorage.removeItem("authToken");
    localStorage.removeItem("token");
    

    // Redirect to the login page
    window.location.replace("/login");
  };

  return (
    <div> 
       <Toaster position="top-center" /> {/* Add Toaster here */}
      <div className="dark-mode-switching"  >
        <div className="d-flex w-100 h-100 align-items-center justify-content-center">
          <div className="dark-mode-text text-center">
            <i className="bi bi-moon"></i>
            <p className="mb-0">Switching to dark mode</p>
          </div>
          <div className="light-mode-text text-center">
            <i className="bi bi-brightness-high"></i>
            <p className="mb-0">Switching to light mode</p>
          </div>
        </div>
      </div>
      <div className="page-content-wrapper py-3">
        <div className="container"  style={{ marginTop: "40px" }}>
          {/* Settings Card */}
          <div className="card mb-3 shadow-sm">
            <div className="card-body direction-rtl">
              {/* <p className="mb-2">Settings</p> */}

              <div className="single-setting-panel">
                <div className="form-check form-switch mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="darkSwitch"
                    checked={isDarkMode}
                    onChange={handleDarkModeToggle}
                  />
                  <label className="form-check-label" htmlFor="darkSwitch">
                    Dark Mode
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Account Setup Card */}
          <div className="card mb-3 shadow-sm">
            <div className="card-body direction-rtl">
              <p className="mb-2">Account Setup</p>

              {/* <div className="single-setting-panel">
                <Link to="/user-profile">
                  <div className="icon-wrapper">
                    <i className="bi bi-person"></i>
                  </div>
                  Update Profile
                </Link>
              </div> */}

              <div className="single-setting-panel">
                <Link to="/update-password">
                  <div className="icon-wrapper bg-info">
                    <i className="bi bi-lock"></i>
                  </div>
                  Change Password
                </Link>
              </div>
            </div>
          </div>

          {/* Register & Logout Card */}
        
              {/* <p className="mb-2">Logout</p> */}

              
                {/* Modify this section to call handleLogout on click */}
                <button onClick={handleLogout} className="btn btn-danger col-12">
                  <div className="icon-wrapper bg-danger">
                    <i className="bi bi-box-arrow-right"></i>
                  </div>
                  Logout
                </button>
              
          
        </div>
      </div>
    </div>
  );
};

export default Settings;
